export default "__VITE_ASSET__C1UPl6QA__"